var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurcahseIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32352 11.0113C1.6739 8.009 2.18585 5.75784 2.66063 4.15851C3.04994 2.84711 3.24459 2.19141 4.04283 1.5957C4.84107 1 5.65697 1 7.28876 1H12.7112C14.343 1 15.1589 1 15.9572 1.5957C16.7554 2.19141 16.9501 2.84711 17.3394 4.15851C17.8142 5.75784 18.3261 8.009 18.6765 11.0113C19.0894 14.5497 19.2959 16.3189 18.1027 17.6594C16.9095 19 14.9758 19 11.1084 19H8.89163C5.02422 19 3.09052 19 1.89731 17.6594C0.704112 16.3189 0.910581 14.5497 1.32352 11.0113Z",
    fill: "white",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00012 5.00049C7.00012 6.65734 8.34325 8.00049 10.0002 8.00049C11.657 8.00049 13.0002 6.65734 13.0002 5.00049",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurcahseIc);
export default __webpack_public_path__ + "static/media/purcahse_ic.55f260913cc7ae772eacb8d9904d3349.svg";
export { ForwardRef as ReactComponent };